import {
  FETCH_ALL_TAGS,
  FETCH_TAGS_FAIL,
  FETCH_TAGS_START,
  FETCH_TAGS_SUCCESS,
  POST_TAG_FAIL,
  POST_TAG_START,
  POST_TAG_SUCCESS,
  RESET_TAGS_LIST,
  UPDATE_TAGS_VALUE
} from "../actionTypes/tagsList";

export const fetchTagsStart = () => ({
  type: FETCH_TAGS_START
});

export const fetchTagsSuccess = tags => ({
  type: FETCH_TAGS_SUCCESS,
  payload: { tags }
});

export const resetTags = () => ({ type: RESET_TAGS_LIST });

export const updateTags = updatedTags => ({
  type: UPDATE_TAGS_VALUE,
  payload: { updatedTags }
});

export const fetchTagsFail = error => ({
  type: FETCH_TAGS_FAIL,
  payload: { error }
});

export const postTagStart = () => ({
  type: POST_TAG_START
});

export const postTagSuccess = payload => ({ type: POST_TAG_SUCCESS, payload });

export const postTagFail = error => ({
  type: POST_TAG_FAIL,
  payload: { error }
});

export const fetchAllTags = tags => ({
  type: FETCH_ALL_TAGS,
  payload: { tags }
});
